import React from 'react';
import type { LucideProps } from 'lucide-react';

type ButtonVariant = 'primary' | 'dark' | 'outline' | 'ghost';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps {
  href: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: React.ComponentType<LucideProps>;
  children: React.ReactNode;
  className?: string;
  target?: '_blank' | '_self';
}

// Botão/link reutilizável com variantes de estilo, tamanho e ícone opcional
const Button: React.FC<ButtonProps> = ({
  href,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  children,
  className = '',
  target,
}) => {
  const variants: Record<ButtonVariant, string> = {
    primary:
      'bg-amber-400 text-gray-900 hover:bg-amber-300 shadow-amber-200/60 border-2 border-transparent',
    dark: 'bg-gray-900 text-white hover:bg-gray-800 border-2 border-transparent',
    outline:
      'bg-white text-gray-900 border-2 border-gray-200 hover:border-amber-400 hover:bg-amber-50',
    ghost:
      'bg-white/20 text-white border-2 border-white/40 hover:bg-white hover:text-gray-900',
  };

  const sizes: Record<ButtonSize, string> = {
    sm: 'px-4 py-2.5 text-xs rounded-xl gap-2',
    md: 'px-5 py-3.5 text-sm rounded-xl gap-2.5',
    lg: 'px-7 py-4 text-[15px] rounded-2xl gap-3',
  };

  return (
    <a
      href={href}
      target={target}
      rel={target === '_blank' ? 'noreferrer noopener' : undefined}
      className={`inline-flex items-center justify-center font-semibold shadow-lg
        transition-all duration-300 hover:scale-[1.03] hover:shadow-xl active:scale-[0.97]
        ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {Icon && <Icon className="h-5 w-5" strokeWidth={1.8} />}
      {children}
    </a>
  );
};

export default Button;

